import React, { createContext, useContext, ReactNode } from 'react';
import { CharacterChargeState } from '../states/game.atoms';

export interface GameActions {
  startGame: () => void;
  dropBall: () => void;
  dropMultipleBalls: (count: number) => void;
  setCharacterState: (state: CharacterChargeState, progress: number) => void;
}

const GameActionsContext = createContext<GameActions | null>(null);

export const useGameActions = () => {
  const context = useContext(GameActionsContext);
  if (!context) {
    throw new Error('useGameActions must be used within a GameActionsProvider');
  }
  return context;
};

interface GameActionsProviderProps {
  actions: GameActions;
  children: ReactNode;
}

export const GameActionsProvider: React.FC<GameActionsProviderProps> = ({ actions, children }) => {
  return (
    <GameActionsContext.Provider value={actions}>
      {children}
    </GameActionsContext.Provider>
  );
};
